module.exports = __webpack_public_path__ + "img/slim_cleanstation32.418c130c.jpg";